import { Button, Flex, Radio } from "antd"
import { Card } from "ui/Card"
import { Text, Title } from "ui/Typography"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"

const DangerActionCard = ({
  title,
  description,
  buttonTitle,
  buttonVariant,
  onClick,
  isActionBtn = true,
  showRadio = false,
  radioProps = {},
  color,
  disabled
}) => {
  return (
    <Card>
      <Flex gap={spacings.XS} vertical>
        {showRadio ? (
          <Radio {...radioProps}>
            <Flex gap={spacings.XXS} vertical>
              <Text fw="700">{title}</Text>
              <Text>{description}</Text>
            </Flex>
          </Radio>
        ) : (
          <>
            <Title level={4}>{title}</Title>
            <Text>{description}</Text>
          </>
        )}
      </Flex>
      {isActionBtn && (
        <Button disabled={disabled} color={color} variant={buttonVariant || "solid"} className="mt-m" size="large" onClick={onClick}>
          {buttonTitle}
        </Button>
      )}
    </Card>
  )
}

DangerActionCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonVariant: PropTypes.string,
  onClick: PropTypes.func,
  isActionBtn: PropTypes.bool,
  showRadio: PropTypes.bool,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  radioProps: PropTypes.object
}

export default DangerActionCard
